// GTM soft-launch (temporary, ~1 month). Flip SOFT_LAUNCH to false to revert
// the navbar/landing changes back to normal. Does not touch auth logic/routes.
export const SOFT_LAUNCH = true;
export const WAITLIST_URL = "https://tally.so/r/vGaDGg";
